module.exports = __webpack_public_path__ + "static/media/wmpt_bg.0329a1e8.png";